import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02b126d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "outer-sphere"
}
const _hoisted_2 = {
  class: "hot-nav",
  ref: "headerMenu"
}
const _hoisted_3 = {
  class: "horizontal-scroll",
  ref: "refClsDiv"
}
const _hoisted_4 = { class: "hot-nav-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Headline = _resolveComponent("Headline")!
  const _component_popular_card = _resolveComponent("popular-card")!
  const _component_Card = _resolveComponent("Card")!

  return ($setup.hotcategory.list && $setup.hotcategory.list.length>0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Card, null, {
          default: _withCtx(() => [
            _createVNode(_component_Headline, {
              title: "Hot Categories",
              more: true,
              size: "18",
              colors: "#000",
              skipPath: "/category"
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hotcategory.list, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "crosswise",
                    key: index,
                    ref_for: true,
                    ref: "refCross"
                  }, [
                    _createVNode(_component_popular_card, {
                      data: item,
                      width: "90"
                    }, null, 8, ["data"])
                  ]))
                }), 128))
              ], 512)
            ], 512),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "hot-nav-bottom-inner",
                style: _normalizeStyle({left:$setup.barMoveWidth + '%'}),
                ref: "refBottom"
              }, null, 4)
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}